import React, { useEffect, useState } from "react";
import { Button, Paper, Stack, Typography, styled } from "@mui/material";

//Styles and Component
//ALl textof project (main texts)

//Splash page top info (brown)
export const SplashInfoPrimary = styled(Typography)(
    ({ theme }) => `
        font-size: ${theme.typography.body1.fontSize};
        color: ${theme.palette.primary.main};
        text-align: center;
        direction: ltr;
    `
)
//Splash page top info (white)
export const SplashInfoSecondary = styled(Typography)(
    ({ theme }) => `
        font-size: ${theme.typography.body2.fontSize};
        color: ${theme.palette.text.white};
        text-align: center;
        direction: ltr;
    `
)
//Login heading text
export const LoginHeading = styled(Typography)(
    ({ theme }) => `
        font-size: ${theme.typography.body1.fontSize};
        color: ${theme.palette.text.dark};
        font-weight: 700;
    `
)
//Login heading text
export const LoginLabel = styled(Typography)(
    ({ theme }) => `
        font-size: ${theme.typography.body2.fontSize};
        color: ${theme.palette.text.dark};
        font-weight: 300;
    `
)
//Pages heading text
export const PageHeading = styled(Typography)(
    ({ theme }) => `
        font-size: ${theme.typography.h4.fontSize} !important;
        font-weight: 700;
    `
)
//Award card heading text
export const CardTitleHead = styled(Typography)(
    ({ theme }) => `
        font-size: ${theme.typography.h5.fontSize};
        color: ${theme.palette.text.primary};
        text-align: center;
        font-weight: 700;
    `
)
//Notif and Ticket card heading text
export const ItemTitleHead = styled(Typography)(
    ({ theme }) => `
        font-size: ${theme.typography.body1.fontSize};
        color: black;
        font-weight: 500;

    `
)
//Notif and Ticket card heading text
export const ItemTitleSmHead = styled(Typography)(
    ({ theme }) => `
        font-size: ${theme.typography.body2.fontSize};
        color: ${theme.palette.secondary.main};
        font-weight: 500;
    `
)
//Notfound text
export const NotfoundText = styled(Typography)(
    ({ theme }) => `
        color: grey;
        text-align: center;
        font-size: 18px;
    `
)
//MessageChatText text
export const MessageChatText = styled(Typography)(
    ({ theme }) => `
        color: black;
        text-align: left;
        font-size: 14px;
    `
)
//MessageChatText text
export const AttachStatusChatText = styled(Typography)(
    ({ theme }) => `
        color: ${theme.palette.text.secondary};
        font-size: 14px;
    `
)
//MessageChatText text
export const ChatTitleText = styled(Typography)(
    ({ theme }) => `
        color: white;
        font-size: 14px;
    `
)
//NoConnection text
export const NoConnectionText = styled(Typography)(
    ({ theme }) => `
        color: black;
        text-align: center;
        font-size: 18px;
    `
)
//NoTicket text
export const NoTicketText = styled(Typography)(
    ({ theme }) => `
        color: grey;
        text-align: center;
        font-size: 18px;
    `
)

//Unique Styles
